export class Constants {
    public static GENERAL_ERROR :string = "Sorry, there was some error in processing your request please try again later.";
  }
 
 